import app from "flarum/forum/app";
import Page from "flarum/common/components/Page";
import PageStructure from "flarum/forum/components/PageStructure";
import Link from "flarum/common/components/Link";
import FactList from "../../common/components/FactList";
import FactDetail from "../../common/components/FactDetail";
import { invalidateFacts } from "../../common/components/FactList";
import { t } from "../../common/api";
export default class FactPage extends Page {
  view() {
    const id = Number(m.route.param("id"));
    return m(PageStructure, {
      className: "FactPage Page--vertical"
    }, m(Link, {
      className: "Button",
      href: app.route("xgayFact") + (id > 0 ? "#" + id : "")
    }, t("stories")), Number.isSafeInteger(id) && id > 0 ? m("div", {
      className: "FactPage-detail"
    }, m(FactDetail, {
      key: id,
      id: id,
      onchanged: invalidateFacts
    })) : m(FactList, {
      open: story => m.route.set(app.route("xgayFactShow", {
        id: story.id
      }))
    }));
  }
}
flarum.reg.add('xgay-fact', 'forum/components/FactPage', FactPage);